// Copyright (c) 2019-present Ithpower, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
import React from 'react';
import {Location, History} from 'history';
import Cookies from 'js-cookie';

import {loadKaiXueBasicParams, loginByKaiXueOauth} from 'server/actions/users';
import {loadEnterpriseAdmins} from 'server/actions/staffs';
import {IsvType} from 'types/users';
import GlobalContext from 'context/global_context';

import {setClientSingalByCookies} from 'utils/utils';

import TripartiteAuthBase, {AuthBaseProps} from './tripartite_auth_base';

const cookieNameToken = 'IAIAUTHTOKEN';
const cookieNameISV = 'IAIISVAPPTYPE';
const LOGIN_REDIRECT = 'http://portal.kaixuecn.com:8888/';

class KaixueSSO extends TripartiteAuthBase {
    userId: string | undefined;
    enterpriseId: string | undefined;
    isvCookie: string | undefined;

    constructor(props: AuthBaseProps) {
        super(props);

        const search = new URLSearchParams(props.location.search);
        this.code = search.get('code');
        this.isvAppType = search.get('isvAppType') as IsvType;
        this.authToken = Cookies.get(cookieNameToken);
        this.isvCookie = Cookies.get(cookieNameISV);
    }

    componentDidMount() {
        if (!this.code || !this.isvAppType) {
            this.handleAuthInvalid();
            return;
        }

        // 使用 code 换取 基本参数
        loadKaiXueBasicParams({
            code: this.code,
            redirect_url: window.location.href,
        }).then(({data}) => {
            if (data) {
                const {user_id, enterprise_id} = data;
                this.userId = user_id;
                this.enterpriseId = enterprise_id;
                if (this.authToken && this.isvAppType === this.isvCookie) {
                    this.verifyEnterpriseInfo();
                } else {
                    this.ssoLogin();
                }
            } else {
                window.location.replace(LOGIN_REDIRECT);
            }
        });
    }

    reTry = () => {
        this.handleStatusInit();
        this.ssoLogin();
    };

    ssoLogin = () => {
        if (this.userId && this.enterpriseId && this.isvAppType) {
            loginByKaiXueOauth({
                user_id: this.userId,
                enterprise_id: this.enterpriseId,
                isv_app_type: this.isvAppType,
            }).then(({error}) => {
                if (error) {
                    this.handleAuthError();
                    return;
                }
                this.finishSignin();
            });
        }
    };

    finishSignin = () => {
        setClientSingalByCookies();
        this.verifyEnterpriseInfo();
    };

    verifyEnterpriseInfo = () => {
        // 登录完成后SESSION_COOKIE_ISVAPPTYPE会被后端写入
        if (!this.code || !this.isvAppType) {
            return;
        }

        let enterpriseId: string | undefined;
        if (typeof document !== 'undefined' && typeof document.cookie !== 'undefined') {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                if (cookie.startsWith('IAIENTERPRISEID=')) {
                    enterpriseId = cookie.replace('IAIENTERPRISEID=', '');
                    break;
                }
            }
        }
        if (!enterpriseId) {
            window.location.replace(LOGIN_REDIRECT);
            return;
        }
        if (this.enterpriseId === enterpriseId) {
            loadEnterpriseAdmins().then(({error, data}) => {
                if (error) {
                    setTimeout(this.verifyEnterpriseInfo, 5000);
                } else if (data && data.length !== 0) {
                    this.redirectToHomePage();
                } else {
                    this.props.history?.replace('/admin_setting');
                }
            });
        } else {
            this.ssoLogin();
        }
    };
}

class WrapperContext extends React.PureComponent<{location: Location, history: History}> {
    render() {
        return (
            <GlobalContext.Consumer>
                {({clientConfig}) =>
                    (<KaixueSSO
                        location={this.props.location}
                        history={this.props.history}
                        clientConfig={clientConfig}
                    />)
                }
            </GlobalContext.Consumer>
        );
    }
}

export default WrapperContext;
